"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adstudio_1 = require("../enums/adstudio");
function defaultElementAnimation() {
    return {
        effect: 'none',
        direction: '',
        delay: 0,
        duration: 1,
        timingFunction: 'linear',
        motionSmoothing: adstudio_1.ANIMATION_MOTION_SMOOTHING_TYPES.IN_OUT,
        intensity: adstudio_1.ANIMATION_INTENSITY_TYPES.MEDIUM,
    };
}
exports.default = defaultElementAnimation;
